module.exports = __webpack_public_path__ + "static/img/service_QRcode.4e5e7852.jpg";